<template>
    <CodiceFeanorView tool-module="aead" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
